import { render, staticRenderFns } from "./IR.vue?vue&type=template&id=999fe7c8&scoped=true&"
import script from "./IR.vue?vue&type=script&lang=js&"
export * from "./IR.vue?vue&type=script&lang=js&"
import style0 from "./IR.vue?vue&type=style&index=0&id=999fe7c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "999fe7c8",
  null
  
)

export default component.exports